import {defineMessages} from 'react-intl';

import {DISPLAY_TYPE_CALENDAR, DISPLAY_TYPE_EVENT_LIST} from '../../utils/constants';

export const messages = defineMessages({
  subHeading: {
    id: 'Partner.SubHeading.Text',
    defaultMessage: 'Tickets',
    description: 'The text to be appended to the end of the Performer Heading',
  },
  heading: {
    id: 'HeroHeader.tickets.title',
    defaultMessage: '{heading} {nestedSubHeading}',
    description: 'The text to be displayed on the Performer Heading',
  },
  date: {
    id: 'Sort.date',
    defaultMessage: 'Date',
  },
  distance: {
    id: 'Sort.distance',
    defaultMessage: 'Distance',
  },
  popularity: {
    id: 'Sort.popular',
    defaultMessage: 'Popular',
  },
  price: {
    id: 'Sort.price',
    defaultMessage: 'Price',
  },
});

export const TabNames = defineMessages({
  [DISPLAY_TYPE_CALENDAR]: {
    id: 'Partner.Tabs.CalendarView',
    defaultMessage: 'Calendar view',
    description: 'The text to be shown for the Calendar view of the tabs',
  },
  [DISPLAY_TYPE_EVENT_LIST]: {
    id: 'Partner.Tabs.ListView',
    defaultMessage: 'List view',
    description: 'The text to be shown for the list view of the tabs',
  },
});
